import type { InitCommandOptions } from '@cli-types/core-engine/commands.js'

export function shouldUseTerminalForDbPush(options: InitCommandOptions): boolean {
  return (
    !options.yes &&
    process.env.CI !== 'true' &&
    Boolean(process.stdin.isTTY) &&
    Boolean(process.stdout.isTTY)
  )
}
